import {useEffect} from "react";

export default function useScrollToTopOnMount() {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, []);

    return null;
}